// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "hugcare" + "." + "14957cb1" + ".js";
};